


























import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
@Component({
  components: {
  }
})
export default class WexDebitCardConfirmDeactivatedCard extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();

  get cardName () {
    return `${this.wexDebitCardsStore.RowSelected.firstName} ${this.wexDebitCardsStore.RowSelected.lastName}`;
  }

}
